import React from 'react';
import PropTypes from 'prop-types';
import { Box, MenuItem } from '@mui/material';
import { SERVICE_AREA_STATES } from '../../../utils/serviceLocation';
import {
  ContactField,
  ContactMethodLabel,
} from '../ContactForServiceModal/ContactForServiceModal.styled';
import { LocationHint, LocationRow } from './ServiceLocationFields.styled';

/** Required city + state (KY / OH / IN) for where the job is. */
const ServiceLocationFields = ({ city, state, errors = {}, onChange, disabled = false }) => (
  <Box>
    <ContactMethodLabel>Where is the job?</ContactMethodLabel>
    <LocationRow>
      <ContactField
        label="City"
        name="city"
        value={city}
        onChange={(e) => onChange({ city: e.target.value, state })}
        error={Boolean(errors.city)}
        helperText={errors.city || undefined}
        required
        fullWidth
        size="small"
        disabled={disabled}
        autoComplete="address-level2"
      />
      <ContactField
        select
        label="State"
        name="state"
        value={state}
        onChange={(e) => onChange({ city, state: e.target.value })}
        error={Boolean(errors.state)}
        helperText={errors.state || undefined}
        required
        fullWidth
        size="small"
        disabled={disabled}
        autoComplete="address-level1"
      >
        {SERVICE_AREA_STATES.map((code) => (
          <MenuItem key={code} value={code}>
            {code}
          </MenuItem>
        ))}
      </ContactField>
    </LocationRow>
    <LocationHint>Pros use this to check they serve your area.</LocationHint>
  </Box>
);

ServiceLocationFields.propTypes = {
  city: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  errors: PropTypes.shape({ city: PropTypes.string, state: PropTypes.string }),
  /** Called with the full `{ city, state }` after either field changes. */
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default ServiceLocationFields;
